import React from 'react';
import { Card, Input, Modal } from 'components';
import { useState } from 'react';
import PasswordInfoModule from './PasswordInfoModule.js';
import { useUpdatePasswordInfoMutation } from 'redux/slices/profile/userInfoApi.js';
import { apiResHandler } from 'utils/axiosBaseQuery.js';
import {
  passwordInfoSelector,
  resetPasswordInfo,
  userInfoSelector,
} from 'redux/slices/profile/UserInfoSlice.js';
import { useDispatch, useSelector } from 'react-redux';
import { addAlertQueue } from 'redux/slices/snackbar/snackbarSlice.js';

const PasswordInfo = () => {
  const passwordInfo = useSelector(passwordInfoSelector);
  const dispatch = useDispatch();
  const profileInfo = useSelector(userInfoSelector);
  const [visibility, setVisibility] = useState(false);
  const handleOnClick = () => {
    setVisibility(true);
  };
  const handleOnClose = () => {
    dispatch(resetPasswordInfo());
    setVisibility(false);
  };
  const [updatePassword] = useUpdatePasswordInfoMutation();

  const handleOnSubmit = () => {
    apiResHandler(
      updatePassword({
        data: {
          userId: profileInfo.userId,
          password1: passwordInfo.password1,
          password2: passwordInfo.password2,
        },
      }),
      () => {
        dispatch(resetPasswordInfo());
        dispatch(
          addAlertQueue({
            message: 'Başarı ile şifre güncellendi.',
            status: 'success',
            show: true,
          })
        );
        setVisibility(false);
      },
      ({ message }) => {
        dispatch(
          addAlertQueue({
            message: message || 'Hata oluştu',
            status: 'error',
            show: true,
          })
        );
      }
    );
  };

  return (
    <>
      <Card className="flex content-start ">
        <div className="text-large text-primary font-bold text-start">
          Şifre Bilgileri
          <div
            onClick={handleOnClick}
            className="float-right block text-ink-dark text-small mt-16 cursor-pointer hover:text-primary "
          >
            Düzenle
          </div>
        </div>

        <>
          <Input
            className="flex  items-center w-auto text-center gap-x-4"
            label="Şifre"
            labelClassName="w-52 text-start"
            inputWrapperClassName="w-72"
            type="text"
            value={'******'}
            disabled
          />
        </>
      </Card>
      <Modal
        className="backdrop-blur w-fit"
        ModalClass="md:p-24"
        ModalContentClass=" "
        isOpen={visibility}
        handleModalClose={handleOnClose}
      >
        <PasswordInfoModule onSubmit={() => handleOnSubmit()} />
      </Modal>
    </>
  );
};

export default PasswordInfo;
